import React, { useState } from 'react';
import './UrpassTicketToggle.css';
import { IonIcon, IonItem, IonLabel } from '@ionic/react';
import { chevronUp, chevronDown } from 'ionicons/icons';
import UrpassTicket from './UrpassTicket';
import { UrpassTicketType } from '../../services/types/urpassapitypes';

type UrpassTicketToggleProps = {
  title: string;
  highlight?: true;
  tickets: UrpassTicketType[] | undefined;
  activateTicket?: (t: UrpassTicketType) => void;
};

export default function UrpassTicketToggle({
  title,
  highlight,
  tickets,
  activateTicket,
}: UrpassTicketToggleProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const hasTickets = tickets && tickets.length > 0;

  let icon;

  if (hasTickets) {
    icon = isOpen ? chevronUp : chevronDown;
  }

  return (
    <div className="pb-1">
      <IonItem
        lines="none"
        className="ion-no-padding ion-pt-1 pseudo-select pseudo-select-active"
        onClick={() => setIsOpen(!isOpen)}
        detail={true}
        detailIcon={icon}
      >
        <IonLabel>
          <strong>{title}</strong>
          {highlight && hasTickets && (
            <span className="urpass-ticket-toggle-hightlight"></span>
          )}
        </IonLabel>
      </IonItem>
      {hasTickets && isOpen && (
        <>
          {tickets.map((ticket: any) => {
            return (
              <UrpassTicket
                activateTicket={activateTicket}
                key={ticket.id}
                ticket={ticket}
              />
            );
          })}
        </>
      )}
    </div>
  );
}
